import { SkillDto, SkillTypeDto } from '@/api/generated';

export type SkillsByType = Record<SkillTypeDto, SkillDto[]>;

export const groupSkillsByType = (skills: SkillDto[]): SkillsByType => {
  return skills.reduce(
    (acc, skill) => ({
      ...acc,
      [skill.type]: [...(acc[skill.type] || []), skill],
    }),
    {} as SkillsByType,
  );
};

const SKILL_TYPE_ORDER: SkillTypeDto[] = [
  SkillTypeDto.ProgrammingLanguage,
  SkillTypeDto.Tool,
  SkillTypeDto.SystemTechnologyMethodology,
  SkillTypeDto.Language,
];

export const getOrderedSkillGroups = (grouped: SkillsByType): [SkillTypeDto, SkillDto[]][] => {
  return SKILL_TYPE_ORDER.map(
    type => [type, grouped[type] || []] as [SkillTypeDto, SkillDto[]],
  ).filter(([, skills]) => skills.length > 0);
};
